import { useState, useEffect } from 'react';
import { message } from 'antd';
import API from '../../API';
import { OrderPriceChange, OrderType } from 'types';

export const usePriceChanges = (orderId: number | undefined, orderType: OrderType) => {
	const [priceChanges, setPriceChanges] = useState<OrderPriceChange[]>();

	const fetchPriceChanges = async () => {
		if (!orderId) {
			return;
		}

		try {
			const result = await API.orders2.order(orderType, orderId).priceChanges();
			setPriceChanges(result);
		} catch (e) {
			console.error(e);
			message.error(`Nie udało się pobrać danych (${e})`);
		}
	};

	useEffect(() => {
		if (orderId) {
			fetchPriceChanges();
		}
	}, [orderId]);

	return [priceChanges, fetchPriceChanges] as const;
};
